import { combineReducers } from 'redux';

import * as PremiumFetchServices from 'js/redux_store/util/fetch_services';
import { analyticsDashboard } from 'js/redux_store/action_types';
import * as MessagesInbox from 'js/redux_store/messages_inbox/actions';
import * as AnalyticsDashboard from 'js/redux_store/analytics_dashboard/actions';
import * as ProfileVisitorCards from 'js/redux_store/profile_visitor_cards/actions';
import assignGlobal from 'js/utils/assign_global';
import StoreBuilder from 'js/utils/store_builder';

const init = new StoreBuilder({
  reducers: require('js/redux_store/reducers'),
});

// hot reload reducers
if (process.env.NODE_ENV === 'hot') {
  if (module.hot) {
    module.hot.accept('js/redux_store/reducers', () => {
      init.store.replaceReducer(
        // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        combineReducers(require('js/redux_store/reducers')),
      );
    });
  }
}

// store and action creators
assignGlobal('Aedu', { ReduxStore: init.store });
assignGlobal('Aedu.WorkConstants', { CV_WORK_ID: 0 });
assignGlobal('Aedu.ActionCreators', {
  MessagesInbox,
  AnalyticsDashboard,
  ProfileVisitorCards,
});

// some parts of the site blindly create actions within React Classes
assignGlobal('Aedu.ActionTypes', { AnalyticsDashboard: analyticsDashboard });

// fetch services for premium upgrade page
assignGlobal('Aedu.Ajax', PremiumFetchServices);
